import { useEffect, useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useTotalHolders = (provider: ethers.ContractRunner | null | undefined) => {
  const [totalHolers, setTotalHolers] = useState(0);
  const tokenAddress = localStorage.getItem("tokenContractAddress");

  useEffect(() => {
    const getTotal = async () => {
      const tokenContract = new ethers.Contract(
        tokenAddress || "",
        ERC20ABI.abi,
        provider
      );

      const res = await tokenContract.getTotalHolders();
      setTotalHolers(Number(res));
    };

    getTotal().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return totalHolers;
};
